import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useAppContext } from "../context/AppState/AppContext";
import AboutUsPage from "../pages/AboutUs/AboutUsPage";
import Contact from "../pages/Contact/Contact";
import Specialties from "../pages/Specialties";
import CourseDetails from "../pages/CourseDetails";
import CoursesPage from "../pages/CoursesPage/CoursesPage";
import PaymentCheckout from "../pages/PaymentCheckout/PaymentCheckout";
import CoursePaymentPage from "../pages/CoursePaymentPage/CoursePaymentPage";
import TransferBankPage from "../pages/TransferBankPage/TransferBankPage";
import Error404Page from "../pages/ErrorPage/Error404Page";
import PreguntasFrecuentes from "../pages/PreguntasFrecuentes/PreguntasFrecuentes";
import Registry from "../pages/Campus/Registry";
import Admin from "../pages/Admin/Admin";
import Inicio from "../pages/Inicio";
import { Loader } from "@mantine/core";

const AppRoutes = () => {
  const { isReady, jsonFeatures } = useAppContext();
  const subscriptionLevel = jsonFeatures.subscriptionLevel;

  return (
    <>
      {isReady === false ? (
        <div style={{
         width: '100vw',
         height: '100vh',
         display: 'grid',
         placeItems: 'center',
        }}><Loader/></div>
      ) : (
        <BrowserRouter>
          <Routes>
            {jsonFeatures?.appRoutes?.inicio[subscriptionLevel] && <Route path="/" element={<Inicio />} />}
            {jsonFeatures?.appRoutes?.aboutUsPage[subscriptionLevel] && <Route path="/institucional" element={<AboutUsPage />} />}
            {jsonFeatures?.appRoutes?.contact[subscriptionLevel] && <Route path="/contacto" element={<Contact />} />}
            {jsonFeatures?.appRoutes?.specialties[subscriptionLevel] && <Route path="/especializaciones/:specialtyId" element={<Specialties />} />}
            <Route path="/curso/:id" element={<CourseDetails />} />
            {jsonFeatures?.appRoutes?.coursesPage[subscriptionLevel] && <Route path="/cursos" element={<CoursesPage />} />}
            {jsonFeatures?.appRoutes?.paymentCheckout[subscriptionLevel] && <Route path="/procesando-pago/" element={<PaymentCheckout />} />}
            <Route path="/pago" element={<CoursePaymentPage />} />
            {jsonFeatures?.appRoutes?.preguntasFrecuentes[subscriptionLevel] && <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />}
            {jsonFeatures?.appRoutes?.transferBankPage[subscriptionLevel] && <Route path="/transferencia-bancaria" element={<TransferBankPage />} />}
            {jsonFeatures?.appRoutes?.error404Page[subscriptionLevel] && <Route path="*" element={<Error404Page />} />}
            {jsonFeatures?.appRoutes?.registry[subscriptionLevel] && <Route path="/campus" element={<Registry />} />}
            {jsonFeatures?.appRoutes?.admin[subscriptionLevel] && <Route path="/admin" element={<Admin />} />}
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
};

export default AppRoutes;
